export const getEPRStyles = (eprType: "EPIC" | "Cerner" | "CareFlow") => {
  const baseStyles = {
    layout: "p-4 rounded-lg border",
    heading: "text-lg font-semibold mb-4",
    text: "text-sm",
  };

  if (eprType === "EPIC") {
    return {
      ...baseStyles,
      container: "bg-blue-50 text-blue-900",
      accent: "bg-blue-500",
      button: "bg-blue-500 hover:bg-blue-600",
    };
  }

  if (eprType === "CareFlow") {
    return {
      ...baseStyles,
      container: "bg-gray-50 text-gray-900",
      accent: "bg-[#f1f3f2]",
      button: "bg-[#f1f3f2] hover:bg-[#e8eae9]",
    };
  }

  return {
    ...baseStyles,
    container: "bg-purple-50 text-purple-900",
    accent: "bg-purple-500",
    button: "bg-purple-500 hover:bg-purple-600",
  };
};
